module.exports = "#pmViewHolder{\r\n    width:1500px;\r\n    height:800px;\r\n    \r\n    margin:30px auto;\r\n    \r\n    padding:20px;\r\n}"